export class DownloadFileInteractor {
  public execute(fileUrl: string): void {
    const element = document.createElement("a");
    element.href = fileUrl;
    element.setAttribute("download", "");
    element.click();
    element.remove();
  }
}
